import React from "react";
import ContentLoader from "react-content-loader";

const DecalarationLoader = () => {
  return (
    <div className="col-lg-4 col-md-6 mb-3 mb-lg-5">
      <div className="card h-100">
        <ContentLoader
          viewBox="0 0 400 150"
          height={150}
          width={400}
          speed={2}
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          {/* Profile and Header */}
          <circle cx="30" cy="30" r="20" />
          <rect x="60" y="15" rx="5" ry="5" width="120" height="10" />
          <rect x="60" y="35" rx="5" ry="5" width="200" height="10" />
          {/* Centre and Ville */}
          <rect x="20" y="60" rx="5" ry="5" width="120" height="10" />
          <rect x="20" y="80" rx="5" ry="5" width="100" height="10" />
          {/* Dates */}
          <rect x="20" y="100" rx="5" ry="5" width="150" height="10" />
          <rect x="200" y="100" rx="5" ry="5" width="120" height="10" />
          {/* Progress */}
          <rect x="20" y="120" rx="5" ry="5" width="300" height="10" />
        </ContentLoader>
      </div>
    </div>
  );
};

export default DecalarationLoader;
